"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferSearchQuerySchema = exports.OfferIdPathParamsSchema = exports.OfferUpdateRequestSchema = exports.OfferCreateRequestSchema = exports.OfferReminderCreateRequestSchema = exports.OfferLetterCreateRequestSchema = void 0;
// offer/requests.ts
const zod_1 = require("zod");
const schemas_1 = require("../../../../schemas");
const offers_1 = require("../../../../schemas/offers");
const offers_validate_1 = require("./offers.validate");
exports.OfferLetterCreateRequestSchema = offers_1.OfferLetterSchema.omit({ id: true });
exports.OfferReminderCreateRequestSchema = offers_1.OfferReminderSchema.omit({ id: true });
exports.OfferCreateRequestSchema = zod_1.z
    .discriminatedUnion('type', [exports.OfferLetterCreateRequestSchema, exports.OfferReminderCreateRequestSchema])
    .superRefine((v, ctx) => (0, offers_validate_1.validateSchedule)(ctx, v, 'isScheduled', 'scheduledAt'));
const OfferLetterUpdateRequestSchema = exports.OfferLetterCreateRequestSchema
    .partial()
    .extend({ type: zod_1.z.literal(offers_1.OfferTypeEnum.enum.OFFER).optional() });
const OfferReminderUpdateRequestSchema = exports.OfferReminderCreateRequestSchema
    .partial()
    .extend({ type: zod_1.z.literal(offers_1.OfferTypeEnum.enum.REMINDER).optional() });
exports.OfferUpdateRequestSchema = zod_1.z
    .union([OfferLetterUpdateRequestSchema, OfferReminderUpdateRequestSchema])
    .superRefine((v, ctx) => (0, offers_validate_1.validateSchedule)(ctx, v, 'isScheduled', 'scheduledAt'));
exports.OfferIdPathParamsSchema = zod_1.z.object({ offerId: schemas_1.UUIDSchema }).strict();
exports.OfferSearchQuerySchema = schemas_1.PaginationQuerySchema.extend({
    type: offers_1.OfferTypeEnum.optional(),
});
